var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-card',{staticClass:"practice-item",attrs:{"color":"white"}},[_c('ion-card-content',[_c('ion-grid',[_c('ion-row',{staticClass:"ion-align-items-center"},[_c('ion-col',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.practice.name)+" ")]),_c('ion-icon',{staticClass:"navigate",attrs:{"name":"ios-arrow-forward"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }